import React from "react"
import { PixiComponent } from "@inlet/react-pixi"
import { Container, Texture } from "pixi.js"
import * as particles from "pixi-particles"

const Emitter = PixiComponent("Emitter", {
  create() {
    return new Container()
  },
  applyProps(instance, oldProps, newProps) {
    const { image, config, x, y } = newProps
    this.sasx = x
    this.sasy = y

    if (!this._emitter) {
      this._emitter = new particles.Emitter(
        instance,
        [Texture.from(image)],
        config
      )

      let elapsed = Date.now()

      const t = () => {
        this._emitter.raf = requestAnimationFrame(t)
        const now = Date.now()

        if (
          this.sasx !== this._emitter.ownerPos.x ||
          this.sasy !== this._emitter.ownerPos.y
        ) {
          //this._emitter.x = this.x
          //this._emitter.y = this.y
          this._emitter.updateOwnerPos(this.sasx, this.sasy)
        }

        this._emitter.update((now - elapsed) * 0.001)

        elapsed = now
      }

      this._emitter.emit = true
      t()
    }
  },
  willUnmount() {
    if (this._emitter) {
      this._emitter.emit = false
      cancelAnimationFrame(this._emitter.raf)
    }
  },
})

export default Emitter
